import axios from 'axios'

export const getMediaUrlContentType = async (url: string) => {
  const { headers } = await axios.get(url, {
    headers: { Range: 'bytes=0-0' },
  })
  return headers['content-type']
}
